<nav-item label="Project"  [hideChevronRight]="true" [ngClass]="{'active': isActive()}">
    <svg-icon key="project" fontSize="1.5rem"></svg-icon>
</nav-item>
